import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

const StyledTitle = styled.div`
  ${({
    theme: {
      fonts: { goodOT },
      colors: {
        grey: { grey_100 },
      },
    },
  }) => {
    return css`
      font-family: ${goodOT};
      font-size: 17px;
      font-weight: 900;
      line-height: 20px;
      color: ${grey_100};
      text-transform: uppercase;
    `
  }}
`

const Title: FunctionComponent<{ children?: ReactNode }> = ({ children }) => {
  return <StyledTitle>{children}</StyledTitle>
}

export default Title
